var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"language-button",style:({ backgroundImage: 'url(' + _vm.languageFlagUrl + ')' }),attrs:{"x-small":"","icon":"","fab":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }